import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

export function useGetFundCategories() {
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/lwadmin/data_provider/fund_categories',
    method: 'GET',
  }, { manual: true });
}

export function createFundCategory(payload) {
  return axios.post('/api/v1/lwadmin/data_provider/fund_category', payload, { headers });
}

export function updateFundCategory(id, payload) {
  return axios.put(`/api/v1/lwadmin/data_provider/fund_category/${id}`, payload, { headers });
}

export function deleteFundCategory(id) {
  return axios.delete(`/api/v1/lwadmin/data_provider/fund_category/${id}`, { headers });
}
